import Header2 from 'elements/Header2';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const Header = Header2.extend`
  padding: 0 ${ds.get('metrics.s')};
  font-size: ${ds.fontSize('l')};    
  color: ${ds.brand('product')};
  margin-bottom: 0;
  margin-top: ${ds.get('metrics.l')};
  
  ${media.tablet`
    font-size: ${ds.fontSize('xl')};
    margin-top: ${ds.get('metrics.l')};
  `}

  ${media.desktop`
    font-size: ${ds.fontSize('xxl')};
    line-height: 1.15;
    margin-top: calc(${ds.get('metrics.xxl')} + ${ds.get('metrics.s')})
  `}
`;

export default Header;



// WEBPACK FOOTER //
// ./src/kentico-blocks/LinkBanner/Header.jsx